module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAJklEQVR4AWMYHOCcoNp/ZMwwi4EoPJwNIBIMYgNAEsTgYWHA8AAAUz44CFYLwAoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/AE.png
// module id = 1068
// module chunks = 0